import ProjectDeviceTypeCustomControls from '@admin/components/projects/ProjectDeviceTypeCustomControls';
import useBreadcrumbs from '@admin/hooks/useAdminBreadcrumbs';
import PageHeader from '@shared/components/core/headers/PageHeader';
import { FlexPageContent } from '@shared/components/core/layouts/CommonLayoutStyles';
import SplashLoader from '@shared/components/loading/SplashLoader';
import useCurrentOrgDetailsFetching from '@shared/hooks/useCurrentOrgDetailsFetching';
import { useCurrentOrgDeviceTypeEditor } from '@shared/hooks/useCurrentOrgDeviceTypeEditor';
import useCurrentOrgProjectsFetching from '@shared/hooks/useCurrentOrgProjectsFetching';
import { useTranslation } from 'react-i18next';
import OrgNoAccessBanner from '@shared/components/organization/banners/OrgNoAccessBanner';
import ProjectsUpgradeBanner from '@shared/components/organization/projects/ProjectsUpgradeBanner';

export default function ProjectDeviceTypeCustomControlsPage() {
    const { t } = useTranslation();
    const { items } = useBreadcrumbs();
    const { currentOrg, canCreateAuthClients, isLoading } = useCurrentOrgDetailsFetching();
    const { currentOrgDeviceType, error, isLoading: isLoadingProject } = useCurrentOrgProjectsFetching();
    useCurrentOrgDeviceTypeEditor(currentOrgDeviceType);

    if (!currentOrgDeviceType || isLoading || isLoadingProject) return <SplashLoader />;
    if (!currentOrg || !canCreateAuthClients || error.device) return <OrgNoAccessBanner />;
    if (!currentOrg.isDeveloperAccess || !currentOrg.canCreateAuthClients) return <ProjectsUpgradeBanner />;

    return (
        <>
            <PageHeader
                title={t('common:organization.projects.deviceType.customControls.title')}
                description={
                    currentOrgDeviceType.name
                        ? `${currentOrgDeviceType.name} — ${t('common:organization.projects.deviceType.customControls.description')}`
                        : t('common:organization.projects.deviceType.customControls.description')
                }
                items={items}
            />
            <FlexPageContent>
                <ProjectDeviceTypeCustomControls />
            </FlexPageContent>
        </>
    );
}
